module.exports = __webpack_public_path__ + "img/refrigerante.8f2772d0.svg";